import { isExisty } from 'utils/helpers.util';
import { hasReachedQtyMinLimit } from './getQuantityLimitStatus.helper';

const getDecreaseButtonProps = ({
  qty,
  min,
  onDecrementHandler,
  onDeleteHandler,
}: {
  [K: string]: any;
}): { [K: string]: any } => {
  const defaultDecreaseButtonProps = {
    isDelete: false,
    onClick: onDecrementHandler,
  };

  if (!isExisty(qty) || !isExisty(min)) {
    return defaultDecreaseButtonProps;
  }

  return {
    ...defaultDecreaseButtonProps,
    ...(hasReachedQtyMinLimit(qty, min)
      ? {
          isDelete: true,
          onClick: onDeleteHandler,
        }
      : {}),
  };
};

export default getDecreaseButtonProps;
